import Navbar from '../visa-travel-tips/components/Navbar';
import Footer from '../visa-travel-tips/components/Footer';
import ArticleContent from './components/ArticleContent';
import ArticleSidebar from './components/ArticleSidebar';

export default function VisaUSGuide() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Breadcrumb */}
      <div className="bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <a href="/" className="hover:text-teal-600 transition-colors cursor-pointer">Trang chủ</a>
            <span>/</span>
            <a href="/visa-travel-tips" className="hover:text-teal-600 transition-colors cursor-pointer">Visa & Travel Tips</a>
            <span>/</span>
            <span className="text-gray-900 font-medium">Hướng dẫn xin Visa du lịch Mỹ</span>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <ArticleContent />
          </div>
          <div className="lg:col-span-1">
            <ArticleSidebar />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}